import Aura from '@primeuix/themes/aura';
import type { PrimeNGConfigType } from 'primeng/config';

export const PRIMENG_CONFIG: PrimeNGConfigType = {
  theme: {
    preset: Aura,
    options: {
      darkModeSelector: '[data-theme="dark"]',
      cssLayer: {
        name: 'primeng',
        order: 'tailwind-base, primeng, tailwind-utilities',
      },
    },
  },
  overlayOptions: {
    appendTo: 'body',
  },
  zIndex: {
    modal: 2500,
    overlay: 2200,
    menu: 2300,
    tooltip: 2400,
  },
  unstyled: false,
};
